module.exports = __webpack_public_path__ + "img/ZFB_PAY.e779eaef.png";